// extracted by mini-css-extract-plugin
export default {"wrapper":"JSONOutput_wrapper__fgzGt"};